var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_291_4446",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 20,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37372 3.45628H17.6263C18.2255 3.45628 18.7158 2.96602 18.7158 2.36681C18.7158 1.7676 18.2255 1.27734 17.6263 1.27734H2.37372C1.77451 1.27734 1.28425 1.7676 1.28425 2.36681C1.28425 2.96602 1.77451 3.45628 2.37372 3.45628ZM18.8901 5.41733C18.792 4.91617 18.3453 4.54575 17.8224 4.54575H2.17761C1.65467 4.54575 1.20799 4.91617 1.10993 5.41733L0.0204651 10.8647C-0.110271 11.5401 0.401779 12.172 1.08814 12.172H1.28425V17.6194C1.28425 18.2186 1.77451 18.7088 2.37372 18.7088H11.0895C11.6887 18.7088 12.1789 18.2186 12.1789 17.6194V12.172H16.5368V17.6194C16.5368 18.2186 17.0271 18.7088 17.6263 18.7088C18.2255 18.7088 18.7158 18.2186 18.7158 17.6194V12.172H18.9119C19.5982 12.172 20.1103 11.5401 19.9795 10.8647L18.8901 5.41733ZM10 16.5299H3.46319V12.172H10V16.5299Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_291_4446)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.00976562,
    width: 20,
    height: 20,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.78345441c4ba6a13991fad2bdf61a93d.svg";
export { ForwardRef as ReactComponent };